module.exports = __webpack_public_path__ + "img/takeLeave_1_en.474eaabf.png";